(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\main.js":[function(require,module,exports){
'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _svgInjector = require('./modules/svgInjector');

var _parallax = require('./modules/parallax');

var _imagePopUp = require('./modules/imagePopUp');

var _carousels = require('./modules/carousels');

var _miniGallery = require('./modules/miniGallery');

var _displayNews = require('./modules/displayNews');

var _cookies = require('./modules/cookies');

var _responsiveImages = require('./modules/responsiveImages');

var _hamburgerMenu = require('./modules/hamburgerMenu');

var _scrollTo = require('./modules/scrollTo');

var _googleMaps = require('./modules/googleMaps');

var _video = require('./modules/video');

var _tabsSection = require('./modules/tabsSection');

var _validator = require('./modules/validator');

var _sidePanel = require('./modules/sidePanel');

var _load = require('./modules/load');

var _accordeon = require('./modules/accordeon');

var _navigation = require('./modules/navigation');

var _visible = require('./modules/visible');

var _sticky = require('./modules/sticky');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var svgInjector = new _svgInjector.SvgInjector();
var parallax = new _parallax.Parallax();
var imagePopUp = new _imagePopUp.ImagePopUp();
var carousels = new _carousels.Carousels();
var miniGallery = new _miniGallery.MiniGallery();
var displayNews = new _displayNews.DisplayNews();
var cookies = new _cookies.Cookies();
var responsiveImages = new _responsiveImages.ResponsiveImages();
var hamburgerMenu = new _hamburgerMenu.HamburgerMenu();
var scrollTo = new _scrollTo.ScrollTo();
var googleMaps = new _googleMaps.GoogleMaps();
var video = new _video.Video();
var tabsSection = new _tabsSection.TabsSection();
var validator = new _validator.Validator();
var sidePanel = new _sidePanel.SidePanel();
var load = new _load.Load();
var accordeon = new _accordeon.Accordeon();
var navigation = new _navigation.Navigation();
var visible = new _visible.Visible();
var sticky = new _sticky.Sticky();

var Main = function () {
  function Main(node_env) {
    _classCallCheck(this, Main);

    this.node_env = node_env;
    this.sections = $('.cms-section');
    jcf.setOptions('Select', {
      wrapNative: false,
      maxVisibleItems: 8
    });
    jcf.replaceAll();
  }

  _createClass(Main, [{
    key: 'bootstrap',
    value: function bootstrap(callback) {
      var $sections = $(this.sections);
      this.modules($sections);
      this.responsiveModules($sections);
      callback();
    }
  }, {
    key: 'modules',
    value: function modules($sections) {
      parallax.init($sections);
      svgInjector.init();
      imagePopUp.init();
      carousels.init();
      miniGallery.init();
      displayNews.init();
      cookies.init();
      responsiveImages.init($sections);
      hamburgerMenu.init();
      scrollTo.init();
      googleMaps.init();
      video.init();
      tabsSection.init();
      validator.init();
      sidePanel.init();
      accordeon.init();
      navigation.init();
      visible.init();
      load.init();
      sticky.init();
    }
  }, {
    key: 'responsiveModules',
    value: function responsiveModules($sections) {
      $(window).resize(function () {
        parallax.init($sections);
        carousels.init();
        miniGallery.init();
        displayNews.init();
        responsiveImages.init($sections);
      });

      $(window).scroll(function () {
        $('.video-player').each(function (id, videoPlayer) {
          if ($(videoPlayer).visible(true)) {
            video.play($(videoPlayer));
          } else {
            video.stop($(videoPlayer));
          }
        });
      });
    }
  }, {
    key: 'Apartament_rodzinny',
    value: function Apartament_rodzinny() {
      fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Apartament', pokoj: 'rodzinny', id: '' });
    }
  }, {
    key: 'Apartament_2_pokojowy',
    value: function Apartament_2_pokojowy() {
      fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Apartament', pokoj: '2_pokojowy', id: 'room-43051' });
    }
  }, {
    key: 'Apartament_3_pokojowy',
    value: function Apartament_3_pokojowy() {
      fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Apartament', pokoj: '3_pokojowy', id: 'room-43052' });
    }
  }, {
    key: 'Standard',
    value: function Standard() {
      fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Standard', pokoj: '2_osobowy', id: 'room-43053' });
    }
  }, {
    key: 'Lux_2_osobowy',
    value: function Lux_2_osobowy() {
      fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Lux', pokoj: '2_osobowy', id: 'room-43049' });
    }
  }, {
    key: 'Lux_3_osobowy',
    value: function Lux_3_osobowy() {
      fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Lux', pokoj: '3_osobowy', id: 'room-43050' });
    }
  }, {
    key: 'Classic_Plus_2_osobowy',
    value: function Classic_Plus_2_osobowy() {
      fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Classic_Plus', pokoj: '2_osobowy', id: 'room-43047' });
    }
  }, {
    key: 'Classic_Plus_3_osobowy',
    value: function Classic_Plus_3_osobowy() {
      fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Classic_Plus', pokoj: '3_osobowy', id: 'room-43048' });
    }
  }, {
    key: 'Classic_2_osobowy',
    value: function Classic_2_osobowy() {
      fbq('track', 'Zarezerwuj_Pokoj', { typ: 'Classic', pokoj: '2_osobowy', id: 'room-43046' });
    }
  }, {
    key: 'Wakacje_nad_morzem',
    value: function Wakacje_nad_morzem() {
      fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Wakacje_nad_morzem', id: 'offer-121990' });
    }
  }, {
    key: 'Sylwester_2018_2019_pobyt_4_dniowy',
    value: function Sylwester_2018_2019_pobyt_4_dniowy() {
      fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Sylwester_2018_2019_pobyt_4_dniowy', id: '' });
    }
  }, {
    key: 'Sloneczny_wrzesien_nad_morzem',
    value: function Sloneczny_wrzesien_nad_morzem() {
      fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Sloneczny_wrzesien_nad_morzem', id: 'offer-122000' });
    }
  }, {
    key: 'Bal_Sylwestrowy_2018_2019',
    value: function Bal_Sylwestrowy_2018_2019() {
      fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Bal_Sylwestrowy_2018_2019', id: '' });
    }
  }, {
    key: 'Mini_Bal_Sylwestrowy',
    value: function Mini_Bal_Sylwestrowy() {
      fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Mini_Bal_Sylwestrowy', id: '' });
    }
  }, {
    key: 'Magiczne_Swieta_Bozego_Narodzenia',
    value: function Magiczne_Swieta_Bozego_Narodzenia() {
      fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Magiczne_Swieta_Bozego_Narodzenia', id: '' });
    }
  }, {
    key: 'Urodziny_dla_dzieci_z_Bowlingiem',
    value: function Urodziny_dla_dzieci_z_Bowlingiem() {
      fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Urodziny_dla_dzieci_z_Bowlingiem', id: '' });
    }
  }, {
    key: 'Promocja_dla_Firm',
    value: function Promocja_dla_Firm() {
      fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Promocja_dla_Firm', id: '' });
    }
  }, {
    key: 'Propozycja_polowinki_grand_2019',
    value: function Propozycja_polowinki_grand_2019() {
      fbq('track', 'Rezerwacja_Oferty', { typ: 'Oferta_specjalna', oferta: 'Propozycja_polowinki_grand_2019', id: '' });
    }
  }]);

  return Main;
}();

$(window).load(function () {
  var main = new Main('development');
  main.bootstrap(function () {
    $('#page-overlay').fadeOut(800);
  });
});

},{"./modules/accordeon":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\accordeon.js","./modules/carousels":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\carousels.js","./modules/cookies":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\cookies.js","./modules/displayNews":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\displayNews.js","./modules/googleMaps":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\googleMaps.js","./modules/hamburgerMenu":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\hamburgerMenu.js","./modules/imagePopUp":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\imagePopUp.js","./modules/load":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\load.js","./modules/miniGallery":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\miniGallery.js","./modules/navigation":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\navigation.js","./modules/parallax":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\parallax.js","./modules/responsiveImages":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\responsiveImages.js","./modules/scrollTo":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\scrollTo.js","./modules/sidePanel":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\sidePanel.js","./modules/sticky":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\sticky.js","./modules/svgInjector":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\svgInjector.js","./modules/tabsSection":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\tabsSection.js","./modules/validator":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\validator.js","./modules/video":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\video.js","./modules/visible":"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\visible.js"}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\accordeon.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Accordeon = exports.Accordeon = function () {
	function Accordeon() {
		_classCallCheck(this, Accordeon);
	}

	_createClass(Accordeon, [{
		key: 'init',
		value: function init() {
			$('.features-list__header').click(function () {
				$(this).closest('.features-list__item').siblings('.features-list__item').find('.features-list__content').slideUp().siblings('.features-list__header').removeClass('active');

				$(this).toggleClass('active').siblings('.features-list__content').slideToggle();
			});
		}
	}]);

	return Accordeon;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\carousels.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Carousels = exports.Carousels = function () {
	function Carousels() {
		_classCallCheck(this, Carousels);
	}

	_createClass(Carousels, [{
		key: 'init',
		value: function init() {
			var carouselThumbs = $('.gallery-thumbs .owl-carousel'),
			    carouselZoom = $('.gallery-category--zoom-slider .owl-carousel'),
			    carouselOffers = $('.gallery-category--offers .owl-carousel'),
			    pluginFlag = carouselOffers.length || carouselThumbs.length || carouselZoom.length;

			if (pluginFlag) if (carouselOffers) this.carouselOffers(carouselOffers);
			if (carouselThumbs) this.carouselThumbs(carouselThumbs);
			if (carouselZoom) this.carouselZoom(carouselZoom);
		}
	}, {
		key: 'carouselOffers',
		value: function carouselOffers(carousel) {
			carousel.owlCarousel({
				items: 3,
				slideBy: 1,
				loop: true,
				mouseDrag: true,
				autolay: false,
				nav: true,
				dots: true,
				thumbs: false,
				stagePadding: 30,
				margin: 30,
				navText: ['<span class="arrow arrow--prev"></span>', '<span class="arrow arrow--next"></span>'],
				responsive: {
					0: {
						items: 1
					},
					641: {
						items: 2
					},
					1024: {
						items: 3
					}
				}
			});
		}
	}, {
		key: 'carouselThumbs',
		value: function carouselThumbs(carousel) {
			carousel.owlCarousel({
				items: 1,
				loop: true,
				margin: 0,
				nav: true,
				navText: ['<img src="./assets/images/icons/arrow-l.svg" alt="" />', '<img src="./assets/images/icons/arrow-r.svg" alt="" />'],
				dots: false,
				thumbs: true,
				thumbsPrerendered: true,
				onChanged: function onChanged(e) {
					var itemsLength = this._items.length;

					var $slider = this.$element.parents('.gallery-thumbs'),
					    $slides = $slider.find('.owl-carousel .owl-item:not(.cloned)'),
					    $thumbs = $slider.find('.gallery-thumbs__thumbs'),
					    $thumbsContainer = $thumbs.find('.gt-thumbs__container'),
					    $thumbsList = $thumbs.find('.owl-thumbs');

					var thumbWidth = $thumbsList.find('.owl-thumb-item').outerWidth(true),
					    thumbsListWidth = thumbWidth * itemsLength,
					    thumbsContainerWidth = $thumbsContainer.width();

					var thumbsOuterWidth = thumbsListWidth - thumbsContainerWidth,
					    thumbsPositionPart = thumbsOuterWidth / itemsLength;

					var currentPosition = $thumbsList.find('.owl-thumb-item.active').index(),
					    currentSlide = $slides.eq(currentPosition);

					if (thumbsOuterWidth > 0) {
						$thumbsList.css({
							'-webkit-transform': 'translateX(' + (-currentPosition + 1) * thumbsPositionPart + 'px)',
							'-mox-transform': 'translateX(' + (-currentPosition + 1) * thumbsPositionPart + 'px)',
							'transform': 'translateX(' + (-currentPosition + 1) * thumbsPositionPart + 'px)'
						});
					}

					setTimeout(function () {
						currentSlide.addClass('active');
					});
				}
			});
		}
	}, {
		key: 'carouselZoom',
		value: function carouselZoom(carousel) {
			carousel.owlCarousel({
				stagePadding: 40,
				loop: true,
				autoWidth: false,
				center: true,
				margin: 0,
				responsive: {
					0: {
						items: 3,
						autoWidth: true
					},
					320: {
						items: 3
					},
					641: {
						items: 3,
						autoWidth: true,
						center: false
					},
					1024: {
						items: 4,
						center: true,
						autoWidth: true
					},
					1350: {
						items: 7,
						center: true,
						autoWidth: true
					}
				}
			});

			carousel.find('.owl-item').on('click', function () {
				var $this = $(this),
				    index = $this.index(),
				    itemsLength = $this.siblings('.owl-item').length,
				    itemsHandler = $this.closest('.owl-stage-outer'),
				    activeItems = $this.closest('.gallery-category--zoom-slider').find('.active');

				if ($this.hasClass('zoomed')) {
					$this.removeClass('zoomed');
				} else if ($this.prev().hasClass('active') && $this.next().hasClass('active') || !$this.prev().hasClass('active') && !$this.next().hasClass('active')) {
					$('.zoomed').removeClass('zoomed');
					$this.addClass('zoomed');
				} else if ($this.prev().hasClass('active') && !$this.next().hasClass('active')) {
					carousel.trigger('next.owl.carousel', [500]);
					$('.zoomed').removeClass('zoomed');
					$this.addClass('zoomed');
				} else if (!$this.prev().hasClass('active') && $this.next().hasClass('active')) {
					carousel.trigger('prev.owl.carousel', [500]);
					$('.zoomed').removeClass('zoomed');
					$this.addClass('zoomed');
				}
			});
		}
	}]);

	return Carousels;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\cookies.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Cookies = exports.Cookies = function () {
	function Cookies() {
		_classCallCheck(this, Cookies);
	}

	_createClass(Cookies, [{
		key: 'init',
		value: function init() {
			$(document).ready(function () {

				if ($.cookie("cookie_agree") == 1) {
					$('.cookies-tab').hide();
				} else {
					$('.cookies-tab').fadeIn(500);
				}

				$('.cookies-tab .button').click(function () {
					cookieAgree();
					return false;
				});
			});

			function cookieAgree() {
				$.cookie("cookie_agree", 1, { expires: 365, path: '/' });
				$('.cookies-tab').fadeOut(400);
			}
		}
	}]);

	return Cookies;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\displayNews.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DisplayNews = exports.DisplayNews = function () {
	function DisplayNews() {
		_classCallCheck(this, DisplayNews);
	}

	_createClass(DisplayNews, [{
		key: 'init',
		value: function init() {
			var newsImage = $('.news--image'),
			    newsBoxes = $('.news--boxes'),
			    windowWidth = $(window).width();

			var newsImageLength = newsImage.length;
			if (newsImageLength) {
				for (var i = newsImageLength; i--;) {
					var thisNews = newsImage[i],
					    thisNewsWidth = $(thisNews).width(),
					    newsImageItems = $(thisNews).find('.news__item'),
					    newsImageItemsLength = newsImageItems.length;

					var largeWidth = 1180 / 12 * 8 + 40,
					    middleWidth = 1180 / 12 * 6 + 40,
					    smallWidth = 1180 / 12 * 4 + 40;

					if ($(thisNews).hasClass('news--image-side')) {
						if (thisNewsWidth < largeWidth && thisNewsWidth >= middleWidth || thisNewsWidth < smallWidth) {
							$(thisNews).find('.news__item').addClass('display-column');
						} else {
							$(thisNews).find('.news__item').removeClass('display-column');
						}
					}
					if (thisNewsWidth < largeWidth && thisNewsWidth >= middleWidth) {
						newsImageItems.removeClass('same-width-1 same-width-2').addClass('same-width-3');
					} else if (thisNewsWidth < middleWidth && thisNewsWidth > smallWidth) {
						newsImageItems.removeClass('same-width-1 same-width-3').addClass('same-width-2');
					} else if (thisNewsWidth < smallWidth) {
						newsImageItems.removeClass('same-width-2 same-width-3').addClass('same-width-1');
					} else {
						newsImageItems.removeClass('same-width-1 same-width-2 same-width-3');
					}
				}
			}

			var newsBoxesLength = newsBoxes.length;
			if (newsBoxesLength) {
				var _loop = function _loop() {
					var thisNews = newsBoxes[i],
					    newsHeight = 0,
					    newsItems = $(thisNews).find('.news__item');

					newsItems.each(function (id, item) {
						var itemHeight = $(item).height();
						if (itemHeight > newsHeight) {
							newsHeight = itemHeight;
						}
					});

					newsItems.find('.ni__content').innerHeight(newsHeight);
				};

				for (var i = newsBoxesLength; i--;) {
					_loop();
				}
			}
		}
	}]);

	return DisplayNews;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\googleMaps.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var GoogleMaps = exports.GoogleMaps = function () {
	function GoogleMaps() {
		_classCallCheck(this, GoogleMaps);
	}

	_createClass(GoogleMaps, [{
		key: 'init',
		value: function init() {
			var self = this;
			if ($('.google-map').length) {
				$(document).ready(function () {
					self.geocode();
				});
			}
		}
	}, {
		key: 'geocode',
		value: function geocode() {
			$('.google-map').each(function (id, mapSection) {
				var address = $(mapSection).data('address'),
				    mapContent = $(mapSection).find('.google-map__content').attr('id'),
				    style,
				    center;

				if ($(this).hasClass('rewa')) {
					style = [{ "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 20 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }];
					center = new google.maps.LatLng(54.548319, 18.365122);
				} else if ($(this).hasClass('grand-rozewie') || $(this).hasClass('wladyslawowo')) {
					style = [{ "featureType": "all", "elementType": "labels.text.fill", "stylers": [{ "saturation": 36 }, { "color": "#333333" }, { "lightness": 40 }] }, { "featureType": "all", "elementType": "labels.text.stroke", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "lightness": 16 }] }, { "featureType": "all", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] }, { "featureType": "administrative", "elementType": "geometry.fill", "stylers": [{ "color": "#fefefe" }, { "lightness": 20 }] }, { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#fefefe" }, { "lightness": 17 }, { "weight": 1.2 }] }, { "featureType": "landscape", "elementType": "geometry", "stylers": [{ "visibility": "on" }, { "lightness": "70" }, { "saturation": "0" }, { "gamma": "1.34" }] }, { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#f5f5f5" }, { "lightness": 21 }] }, { "featureType": "poi.park", "elementType": "geometry", "stylers": [{ "color": "#dedede" }, { "lightness": 21 }] }, { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ba9450" }, { "lightness": 17 }] }, { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#ffffff" }, { "lightness": 29 }, { "weight": 0.2 }] }, { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#d2ab67" }, { "lightness": 18 }] }, { "featureType": "road.local", "elementType": "geometry", "stylers": [{ "color": "#f2e6d2" }, { "lightness": 16 }] }, { "featureType": "transit", "elementType": "geometry", "stylers": [{ "color": "#f2f2f2" }, { "lightness": 19 }] }, { "featureType": "water", "elementType": "geometry", "stylers": [{ "color": "#e9e9e9" }, { "lightness": 17 }] }, { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#e4e4e4" }] }];
					center = new google.maps.LatLng(54.728252, 18.211160);
				}
				var mapOptions = {
					zoom: 11,
					// center: new google.maps.LatLng(40.6700, -73.9400),
					styles: style
				};

				var mapElement = document.getElementById(mapContent);

				var map = new google.maps.Map(mapElement, mapOptions);
				var geocoder = new google.maps.Geocoder();
				geocoder.geocode({ 'address': address }, function (results, status) {
					if (status == google.maps.GeocoderStatus.OK) {
						map.setCenter(center);
						var marker = new google.maps.Marker({
							map: map,
							position: results[0].geometry.location
						});
					}
				});
			});
		}
	}]);

	return GoogleMaps;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\hamburgerMenu.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var HamburgerMenu = exports.HamburgerMenu = function () {
	function HamburgerMenu() {
		_classCallCheck(this, HamburgerMenu);
	}

	_createClass(HamburgerMenu, [{
		key: 'init',
		value: function init() {
			var $mobileNav = $('.mobile-nav'),
			    $hamburger = $('.js-mobile-nav'),
			    $navElements = $mobileNav.find('.mobile-nav__content li');

			$('.js-mobile-nav').on('click', function () {
				$hamburger.toggleClass('is-active');
				$mobileNav.fadeToggle(function () {
					if ($mobileNav.is(':visible')) {
						for (var i = 0; i < $navElements.length; i++) {
							$($navElements[i]).css({ 'transition-delay': i * 50 + 'ms' }).addClass('fadeIn');
						}
					} else {
						$navElements.removeClass('fadeIn');
					}
				});
			});
		}
	}]);

	return HamburgerMenu;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\imagePopUp.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ImagePopUp = exports.ImagePopUp = function () {
  function ImagePopUp() {
    _classCallCheck(this, ImagePopUp);
  }

  _createClass(ImagePopUp, [{
    key: 'init',
    value: function init() {
      $('.picture').each(function () {
        if ($(this).hasClass('picture--video')) {
          $(this).find('a').magnificPopup({
            type: 'iframe',
            mainClass: 'mfp-fade',
            removalDelay: 160,
            preloader: false,
            fixedContentPos: false
          });
        } else {
          $(this).find('a').magnificPopup({
            type: 'image',
            closeOnContentClick: true,
            closeBtnInside: false,
            fixedContentPos: true,
            mainClass: 'mfp-no-margins mfp-with-zoom',
            image: {
              verticalFit: true
            },
            zoom: {
              enabled: true,
              duration: 300
            }
          });
        }
      });
    }
  }]);

  return ImagePopUp;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\load.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Load = exports.Load = function () {
	function Load() {
		_classCallCheck(this, Load);
	}

	_createClass(Load, [{
		key: 'init',
		value: function init() {
			setTimeout(function () {
				document.body.classList.add('render');
			}, 60);
			var self = this;
			var a = Array.from(document.querySelectorAll('a:not(.picture):not(.mini-gallery__link):not(.embed):not(.js-wis2-open-booking):not(.button--reservation):not(.download__link)'));

			a.forEach(function (el) {
				el.addEventListener('click', function (ev) {
					var target = ev.currentTarget;
					var check = target.href.match(/\bdownload|^[tmf]|^\#$/gm);

					if (check != null) {
						ev.preventDefault();
						self.navigate(target);
					}
				});
			});
		}
	}, {
		key: 'navigate',
		value: function navigate(linkEl) {
			document.getElementsByTagName('html')[0].classList.add('no-scroll');
			document.body.classList.remove('render');
			document.body.addEventListener('transitionend', function () {
				window.location = linkEl.href;
			});
		}
	}]);

	return Load;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\miniGallery.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MiniGallery = exports.MiniGallery = function () {
	function MiniGallery() {
		_classCallCheck(this, MiniGallery);
	}

	_createClass(MiniGallery, [{
		key: 'init',
		value: function init() {
			var miniGalleryLength = $('.mini-gallery').length,
			    noGridGalleryLength = $('.js-no-grid').length;

			if (miniGalleryLength) {
				for (var i = miniGalleryLength; i--;) {
					var element = $('.mini-gallery')[i];
					$(element).magnificPopup({
						delegate: 'a',
						type: 'image',
						closeOnContentClick: true,
						closeBtnInside: false,
						fixedContentPos: true,
						mainClass: 'mfp-no-margins mfp-with-zoom', // class to remove default margin from left and right side
						image: {
							verticalFit: true
						},
						tLoading: 'Ładuję...',
						gallery: {
							enabled: true,
							tCounter: '<span class="mfp-counter">%curr% z %total%</span>'
						},
						zoom: {
							enabled: false,
							duration: 300 // don't foget to change the duration also in CSS
						}
					});
				}
			}

			if (noGridGalleryLength) {
				var noGridGalleries = $('.js-no-grid');
				noGridGalleries.each(function (galleryId, gallery) {
					var galleryItems = $(gallery).find('.js-no-grid-item'),
					    galleryColumns = $(gallery).data('columns') ? $(gallery).data('columns') : 3,
					    galleryContainerColumns = null,
					    galleryItemsArary = [];

					var galleryContainer = $('<div class="row"></div>');
					for (var i = 0; i < galleryColumns; i++) {
						var galleryCol = $('<div class="col-md-' + 12 / galleryColumns + '"></div>');
						galleryContainer.append(galleryCol);
					}

					$(gallery).append(galleryContainer);
					galleryContainerColumns = galleryContainer.find('[class*="col-md"]');

					galleryItems.each(function (id, galleryItem) {
						var minHeight = 10000000000,
						    selectedCol = null;
						for (var i = 0; i < galleryContainerColumns.length; i++) {
							var colHeight = $(galleryContainerColumns[i]).height();

							if (colHeight < minHeight) {
								minHeight = colHeight;
								selectedCol = $(galleryContainerColumns[i]);
							}
						}
						selectedCol.append($(galleryItem).clone(true));
					});
					$(gallery).html(galleryContainer);
				});
			}
		}
	}]);

	return MiniGallery;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\navigation.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Navigation = exports.Navigation = function () {
	function Navigation() {
		_classCallCheck(this, Navigation);
	}

	_createClass(Navigation, [{
		key: 'init',
		value: function init() {
			$('.site-header li').each(function () {
				var $this = $(this);
				if ($this.children('.submenu').length) {
					$this.addClass('has-child');
				} else if ($this.children('ul').length) {
					$this.addClass('has-list');

					var w = $this.innerWidth();
					$this.closest('.submenu').css('width', w += w);
				}
			});

			var dropdown = $('.site-header__left .dropdown-menu'),
			    w = dropdown.find('strong').outerWidth();

			dropdown.find('ul').width(Math.floor(w));

			var len = $('.articles-list--3').find('.articles-list__item').length;
			len == 3 ? '' : $('.offers-button').hide();
		}
	}]);

	return Navigation;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\parallax.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Parallax = exports.Parallax = function () {
  function Parallax() {
    _classCallCheck(this, Parallax);
  }

  _createClass(Parallax, [{
    key: 'init',
    value: function init($sections) {
      if ($(window).width() > 1020) {
        $(window).scroll(function () {
          var wScrollTop = $(window).scrollTop();
          $('.cms-section[data-parallax="true"]').each(function (id, item) {
            if ($(this).visible(true)) {
              var itemTop = $(this).offset().top;
              var s = wScrollTop - itemTop;
              $(this).find('.s-background .s-background__img').css({
                'transform': 'translateY(' + s * 0.15 + 'px)',
                '-webkit-transform': 'translateY(' + s * 0.15 + 'px)',
                '-moz-transform': 'translateY(' + s * 0.15 + 'px)'
              });
            }
          });
        });
      }
    }
  }]);

  return Parallax;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\responsiveImages.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResponsiveImages = exports.ResponsiveImages = function () {
	function ResponsiveImages() {
		_classCallCheck(this, ResponsiveImages);
	}

	_createClass(ResponsiveImages, [{
		key: 'init',
		value: function init($sections) {
			var imagesSrc = $sections.find('.js-image-src'),
			    windowSize = $(window).width() <= 720 ? 'mobile' : 'desktop';

			for (var i = imagesSrc.length; i--;) {
				var item = $(imagesSrc[i]);
				if (item.data('src-type') === 'background') {
					item.css({ 'background-image': 'url("' + item.data('image-src-' + windowSize) + '")' });
				} else {
					item.attr('src', item.data('image-src-' + windowSize));
				}
			}
		}
	}]);

	return ResponsiveImages;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\scrollTo.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ScrollTo = exports.ScrollTo = function () {
	function ScrollTo() {
		_classCallCheck(this, ScrollTo);
	}

	_createClass(ScrollTo, [{
		key: 'init',
		value: function init() {
			$('.scroll-to a').on('click', function (e) {
				e.preventDefault();
				var distElement = $(this).attr('href'),
				    distElementTop = $(distElement).offset().top - 15;

				$('html, body').animate({
					scrollTop: distElementTop
				}, 500);
			});
		}
	}]);

	return ScrollTo;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\sidePanel.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SidePanel = exports.SidePanel = function () {
	function SidePanel() {
		_classCallCheck(this, SidePanel);
	}

	_createClass(SidePanel, [{
		key: 'init',
		value: function init() {
			if ((typeof sidePanelOptions === 'undefined' ? 'undefined' : _typeof(sidePanelOptions)) == 'object') {
				var self = this,
				    currentCookie = $.cookie('side-panel-' + sidePanelOptions.siteId) ? $.parseJSON($.cookie('side-panel-' + sidePanelOptions.siteId)) : undefined,
				    body = $('body');

				$.cookie.json = true;

				$(document).ready(function () {
					if (currentCookie == undefined || currentCookie.id != sidePanelOptions.id) {
						sidePanelOptions.closed = 0;
						$.cookie('side-panel-' + sidePanelOptions.siteId, sidePanelOptions, { expires: 365, path: '/' });
						self.checkRevealType();
					} else {
						if (currentCookie.closed == 0 && sidePanelOptions.reactive == 0 || currentCookie.closed == 1 && currentCookie.reactive == 0 && sidePanelOptions.reactive == 1) {
							self.checkRevealType();
						}
					}

					body.on('click', '.side-panel__close', function () {
						self.hidePanel();
					});
					body.on('click', '.side-panel.close', function () {
						self.reopenPanel();
					});
				});
			}
		}
	}, {
		key: 'reopenPanel',
		value: function reopenPanel() {
			$('.side-panel').fadeOut(function () {
				$(this).removeClass('close').addClass('open').fadeIn();
			});
		}
	}, {
		key: 'showPanel',
		value: function showPanel() {
			$('.side-panel').fadeIn(function () {
				$(this).removeClass('close').addClass('open');
			});
		}
	}, {
		key: 'hidePanel',
		value: function hidePanel() {
			$('.side-panel').fadeOut(function () {
				$(this).removeClass('open').addClass('close').show();
			});
			var cookie = $.cookie('side-panel-' + sidePanelOptions.siteId);

			cookie.closed = 1;
			sidePanelOptions.reactive == 1 ? cookie.reactive = 1 : cookie.reactive = 0;
			$.cookie('side-panel-' + sidePanelOptions.siteId, cookie, { expires: 365, path: '/' });
		}
	}, {
		key: 'showAfterTime',
		value: function showAfterTime(time) {
			var self = this;
			var delay = parseInt(time) * 1000;
			setTimeout(function () {
				self.showPanel();
			}, delay);
		}
	}, {
		key: 'showAfterDistance',
		value: function showAfterDistance(distance) {
			var self = this,
			    notClosed = true;
			$(window).scroll(function () {
				var st = $(window).scrollTop();

				if (st > distance && notClosed) {
					self.showPanel();
					notClosed = false;
				}
			});
		}
	}, {
		key: 'checkRevealType',
		value: function checkRevealType() {
			var self = this;

			if (sidePanelOptions.distance != 0) {
				self.showAfterDistance(sidePanelOptions.distance);
			} else if (sidePanelOptions.time != 0) {
				self.showAfterTime(sidePanelOptions.time);
			}
		}
	}]);

	return SidePanel;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\sticky.js":[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Sticky = exports.Sticky = function () {
	function Sticky() {
		_classCallCheck(this, Sticky);
	}

	_createClass(Sticky, [{
		key: "init",
		value: function init() {
			$(document).ready(function () {
				$(".reservation-box").first().stick_in_parent();
			});
		}
	}]);

	return Sticky;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\svgInjector.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var SvgInjector = exports.SvgInjector = function () {
	function SvgInjector() {
		_classCallCheck(this, SvgInjector);
	}

	_createClass(SvgInjector, [{
		key: 'init',
		value: function init() {
			var mySVGsToInject = document.querySelectorAll('img.inject-svg');
			SVGInjector(mySVGsToInject, {}, function () {
				$('.contact-map--transparent path').hover(function () {
					var pathID = $(this).attr('id');
					$('.contact-map--color path[id="' + pathID + '"]').css({ 'fill': '#003179' });
				}, function () {
					$('.contact-map--color path').css({ 'fill': 'rgb(210, 220, 237)' });
				});

				$('.contact-map--transparent path').on('click', function () {
					$('.map-infos').hide();
					var tabID = $(this).attr('id');
					$('.contact-map--color path').attr('class', 'swisspor-area');
					$('.contact-map--color path[id="' + tabID + '"]').attr('class', 'swisspor-area active');
					$('.map-item').hide();
					$('.map-item[data-tab="' + tabID + '"]').show();
				});

				$('.js--regions').on('click', function () {
					$(this).closest('.map-item__regions').find('.regions-list').slideToggle();
				});
			});
		}
	}]);

	return SvgInjector;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\tabsSection.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TabsSection = exports.TabsSection = function () {
	function TabsSection() {
		_classCallCheck(this, TabsSection);
	}

	_createClass(TabsSection, [{
		key: 'init',
		value: function init() {
			var $tabsSections = $('.cms-section[data-tabs="true"]');
			if ($tabsSections.length) {
				$tabsSections.each(function (tabsSectionId, tabsSection) {
					var $tabsSection = $(tabsSection),
					    $tabsSectionItems = $tabsSection.find('.section-tab'),
					    tabsNames = [];

					var $tabsSectionButtons = $('<div />', { 'class': 'section-tabs__buttons' }).append($('<ul />'));
					$tabsSectionItems.each(function (sectionItemId, sectionItem) {
						var $sectionItem = $(sectionItem);
						var $tabButton = $('<button />', { 'class': 'section-tabs__button js-section-tabs-button', 'data-id': $sectionItem.attr('id') }).html($sectionItem.data('tab-name'));

						if (sectionItemId != 0) $sectionItem.hide();else $tabButton.addClass('active');

						$tabsSectionButtons.find('ul').append($('<li />').append($tabButton));
					});
					$tabsSection.find('.s-content').prepend($tabsSectionButtons);
				});
			}

			this.actions();
		}
	}, {
		key: 'actions',
		value: function actions() {
			$('.js-section-tabs-button').on('click', function (e) {
				var $tabButton = $(this),
				    $tabId = $tabButton.data('id'),
				    $parentSection = $tabButton.closest('.cms-section');

				if (!$tabButton.hasClass('active')) {
					$parentSection.find('.section-tab').fadeOut(300);
					$parentSection.find('.section-tabs__button').removeClass('active');

					setTimeout(function () {
						$tabButton.addClass('active');
						$('#' + $tabId).fadeIn();
					}, 300);
				}
			});
		}
	}]);

	return TabsSection;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\validator.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Validator = exports.Validator = function () {
	function Validator() {
		_classCallCheck(this, Validator);
	}

	_createClass(Validator, [{
		key: 'init',
		value: function init() {
			if ((typeof contactFormRules === 'undefined' ? 'undefined' : _typeof(contactFormRules)) == 'object') {
				$('#contactForm').validate({
					rules: contactFormRules,
					errorPlacement: function errorPlacement(error, element) {},
					submitHandler: function submitHandler(text) {
						$.ajax({
							url: $('#contactForm').attr("action"),
							method: 'POST',
							data: $('#contactForm').serialize(),
							beforeSend: function beforeSend() {
								$('#contactForm').find('button').prop('disabled', 'disabled');
							},
							success: function success() {
								$('#contactForm').find('input, textarea').val('');
								$('#contactForm').fadeOut(500, function () {
									$('#contactForm').replaceWith('<div class="form__message form__message--success">Wiadomość została wysłana. Dziękujemy.</div>').fadeIn(500);
								});
							},
							error: function error(a, b, c) {
								$('#contactForm').find('input, textarea').val('');
								$('#contactForm').fadeOut(500, function () {
									$('#contactForm').replaceWith('<div class="form__message form__message--error">Wiadomość nie została wysłana. Prosimy spróbować później.</div>').fadeIn(500);
								});
							}
						});
					}
				});
			}
		}
	}]);

	return Validator;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\video.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Video = exports.Video = function () {
	function Video() {
		_classCallCheck(this, Video);
	}

	_createClass(Video, [{
		key: 'init',
		value: function init() {
			var self = this;
			$('.video-player').hover(function (e) {
				e.preventDefault();
				var $this = $(this);
				self.play($this);
			}, function (e) {
				e.preventDefault();
				var $this = $(this);
				self.stop($this);
			});
		}
	}, {
		key: 'play',
		value: function play(video) {
			var videoType = video.data('type');
			if (videoType == 'youtube') {
				video = $(video)[0].contentWindow;
				video.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
			} else if (videoType == 'video') {
				video = video.get(0);
				video.play();
			}
		}
	}, {
		key: 'stop',
		value: function stop(video) {
			var videoType = video.data('type');
			if (videoType == 'youtube') {
				video = $(video)[0].contentWindow;
				video.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
			} else if (videoType == 'video') {
				video = video.get(0);
				video.pause();
			}
		}
	}]);

	return Video;
}();

},{}],"D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\modules\\visible.js":[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Visible = exports.Visible = function () {
	function Visible() {
		_classCallCheck(this, Visible);
	}

	_createClass(Visible, [{
		key: 'init',
		value: function init() {
			var elem = $('.features-list__item, .text, .picture, .button:not(".section-tabs__button, .center-block"), .download__file, .articles-list__item, .mini-gallery__item');

			elem.each(function () {
				var $this = $(this),
				    elemVisible = $this.visible(true, 'vertical');

				if (elemVisible) $this.addClass('on-screen', elemVisible);
			});

			$(window).scroll(function () {
				elem.each(function () {
					var $this = $(this),
					    elemVisible = $this.visible(true, 'vertical');

					if (elemVisible) $this.addClass('on-screen', elemVisible);
				});
			});

			this.delay($('.articles-list--blog .articles-list__item'));
			this.delay($('.download .download__file'));
			// this.delay($('.features-list--numbers-vert .features-list__item'));
			// this.delay($('.features-list--numbers-vert .features-list__item'));
			// this.delay($('.features-list--realizations .features-list__item'));
			// this.delay($('.articles-list .al-item__picture'));
		}
	}, {
		key: 'delay',
		value: function delay(elem) {
			elem.each(function (index) {
				$(this).css('transition-delay', 100 * index + 'ms');
			});
		}
	}]);

	return Visible;
}();

},{}]},{},["D:\\htdocs\\okulski\\www\\resources\\assets\\scripts\\src\\main.js"])

